<template>
    <section class="section__explosive">
            <h1>Our Explosive new lineup.</h1>
            <span class="text__span3">Best kits for Newcomers.</span>
            <div class="images">
                <img src="/assets/Untitled-1.png" alt="TnT-Kit" id="tnt-kit">
            </div>
    </section>
</template>

<script>
export default {
    name: 'Explosive'
}
</script>

<style scoped>
    .section__explosive {
        width: 100%;
        background-color: #fff;
        background-repeat: no-repeat;
        background-position: center;
        background-size: 600px;
    }

    .text__span1 {
        text-transform: uppercase;
        font-size: 2.2rem;
        padding: 0 8px;
        background-color: #4ec7f3;
    }

    .section__explosive h1 {
        /* margin-top: 2rem; */
        font-size: 2.3rem;
    }

    .section__explosive .text__span3 {
        font-size: 1.2rem;
    }

    .images {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        padding: 2rem 0 2rem;
    }

    .section__explosive span {
        font-size: 1.5rem;
        font-weight: 600;
    }

    .section__explosive .text__span4 {
        font-weight: 600;
    }
</style>
